<template>
  <v-icon
    color="white"
    class="instagram-icon"
    v-text="'mdi-instagram'"
  />
</template>

<script>
export default {
  name: 'InstagramIcon',
};
</script>

<style lang="scss" scoped>
.instagram-icon {
  background: #d6249f;
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285AEB 90%
  );
  box-shadow: 0px 3px 10px rgba(0,0,0,.25);  border-radius: 5px;
}
</style>
